export default "__VITE_ASSET__DjhO1tne__"